
import { getAiConversationsList } from '@/api/home/market';

const state = {
  conversationList: [],
  pagination: {
    page: 1,
  },
}
const mutations = {
  setConversationList(state, payload) {
    state.conversationList = payload;
  },
  setPagination(state, payload) {
    state.pagination = payload;
  }
}
const actions = {
  async getConversationsList({ commit, state }, val) {
    // Callers group / paginate off this return value, so never resolve undefined.
    const fallback = {
      conversations: state.conversationList,
      pagination: state.pagination,
    };
    try {
      const params = {
        profile_id: this.state.user.currentId.profile_id,
        per_page: 25,
        page: 1,
        ...val,
      }
      const data = await getAiConversationsList(params);
      if (!data) {
        return fallback;
      }
      const conversations = data.data?.conversations || [];
      const pagination = data.data?.pagination || state.pagination;
      let list = [];
      if (params.page === 1) {
        list = conversations;
      } else {
        list = [...state.conversationList, ...conversations]
      }
      commit('setConversationList', list);
      commit('setPagination', pagination);
      return {
        conversations: list,
        pagination,
      };
    } catch (error) {
      return fallback;
    }
  },

};

export default{
  namespaced: true,
  state,
  mutations,
  actions,
}
